module.exports = __webpack_public_path__ + "assets/w3w-1e5c24e48306246b6995384700ce807e.svg";